<template>
  <div class="p-8">
    <div class="relative flex min-w-0">
      <div class="flex-1">
        <TextArea
          :id="id"
          auto-expand
          :label-name="labelName"
          :model-value="modelValue"
          :disabled="disabled || loading"
          :prevent-enter-default="true"
          prop-classes="!pr-[30px] max-h-[160px]"
          :rows="1"
          @enter="onEnter"
          @update:model-value="$emit('update:modelValue', $event)"
        />
      </div>
      <button
        v-if="trimmedValue"
        class="!absolute bottom-[14px] right-[14px]"
        :aria-disabled="disabled || loading"
        aria-label="Send message"
        @click="$emit('send')"
      >
        <send-icon aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import SendIcon from '@/graphics/icons/SendIcon.vue';

export default {
  name: 'MessageComposer',
  components: {
    TextArea,
    SendIcon,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    id: {
      type: String,
      default: 'message-composer',
    },
    labelName: {
      type: String,
      default: 'Message',
    },
    modelValue: {
      type: String,
      default: '',
    },
    sendLabel: {
      type: String,
      default: 'Send',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    trimmedValue(): string {
      return this.modelValue.trim();
    },
  },
  methods: {
    onEnter() {
      if (this.trimmedValue) this.$emit('send');
    },
  },
};
</script>
